import { dom } from '@Core/dom/Dom';
import { Mask } from './Mask';
export class ElementByLengthModel {
    constructor(updatedElement, lastTrimElement) {
        this.updatedElement = updatedElement;
        this.lastTrimElement = lastTrimElement;
    }
}
export class MarkElementMask extends Mask {
    constructor() {
        super(...arguments);
        this.markClass = "mark-text";
    }
    markExcluded(element) {
        let excluded = this.getExcludedElements(element);
        excluded.forEach((exclude) => {
            this.markElement(exclude);
            this.markChildren(exclude.children);
        });
    }
    splitElement(element) {
        this.unMarkRootIfNotExcluded(element);
        const clonedNode = element;
        // TODO: if we decide not to mutate the original element
        // then to restore we need to use the element (maskElement) itself and not its originalContent
        //const clonedNode = element.cloneNode(true);
        //element.replaceWith(clonedNode);    // must be insert in DOM before visibility check
        const textNodes = this.getTextNodes(clonedNode, []);
        let length = 0;
        const allowedCount = this.maskingOptions.AllowedCharactersCount;
        let lastTrimElement = null;
        for (let node of textNodes) {
            const parentElement = node.parentNode;
            this.markParentsToRootElement(node, element);
            let content = node.textContent || "";
            if (content.trim().length === 0) {
                content = "";
            }
            const currentLength = content.length;
            if (length + currentLength < allowedCount) {
                length += currentLength;
                continue;
            }
            let uncutParent = this.getUncutParent(node, element);
            if (!!uncutParent) {
                let terminator = document.createElement('SPAN');
                terminator.appendChild(document.createTextNode(' ' + this.maskingOptions.Terminator));
                uncutParent.insertAdjacentElement("afterend", terminator);
                this.lastTrimNode = terminator;
                lastTrimElement = this.lastTrimNode.parentNode;
                this.wrapNextTextNodes(this.lastTrimNode, element);
                this.markElement(this.lastTrimNode);
                break;
            }
            // cut by allowedCount
            const charactersLeft = allowedCount - length;
            const contentBefore = content.substr(0, charactersLeft);
            node.textContent = contentBefore;
            // set terminator after that
            node.textContent += ` ${this.maskingOptions.Terminator}`;
            this.lastTrimNode = node;
            lastTrimElement = parentElement;
            // append cutted content as next sibling
            const contentAfter = content.substr(charactersLeft);
            const contentNodeAfter = document.createTextNode(contentAfter);
            parentElement.insertBefore(contentNodeAfter, node.nextSibling);
            // wrap all text nodes  by span from contentAfter
            this.wrapNextTextNodes(node, element);
            break;
        }
        return new ElementByLengthModel(clonedNode, lastTrimElement);
    }
    splitElementFade(element) {
        this.unMarkRootIfNotExcluded(element);
        const clonedNode = element;
        const textNodes = this.getTextNodes(clonedNode, []);
        let length = 0;
        let allowedCount;
        if (!this.maskingOptions.AllowedCharactersCount) {
            allowedCount = element.innerText.length - this.maskingOptions.AllowedFadedCharactersCount;
        }
        else {
            allowedCount = this.maskingOptions.AllowedCharactersCount - this.maskingOptions.AllowedFadedCharactersCount;
        }
        let lastTrimElement = null;
        for (let node of textNodes) {
            let content = node.textContent || "";
            const parentElement = node.parentNode;
            this.markParentsToRootElement(node, element);
            if (content.trim().length === 0) {
                content = "";
            }
            const currentLength = content.length;
            if (length + currentLength < allowedCount) {
                length += currentLength;
                continue;
            }
            let uncutParent = this.getUncutParent(node, element);
            if (!!uncutParent) {
                let terminator = document.createElement('SPAN');
                uncutParent.insertAdjacentElement("afterend", terminator);
                this.lastTrimNode = terminator;
                break;
            }
            // cut by allowedCount
            const charactersLeft = allowedCount - length;
            const contentBefore = content.substr(0, charactersLeft);
            node.textContent = contentBefore;
            // set terminator after that
            node.textContent += ` ${this.maskingOptions.Terminator}`;
            this.lastTrimNode = node;
            lastTrimElement = parentElement;
            // append cutted content as next sibling
            const contentAfter = content.substr(charactersLeft);
            const contentNodeAfter = document.createTextNode(contentAfter);
            parentElement.insertBefore(contentNodeAfter, node.nextSibling);
            // wrap all text nodes  by span from contentAfter
            this.wrapNextTextNodes(node, element);
            break;
        }
        return new ElementByLengthModel(clonedNode, lastTrimElement);
    }
    getLastTrimNode() {
        return this.lastTrimNode;
    }
    getLastMarkElement(element) {
        if (this.lastTrimNode) {
            return this.lastTrimNode.parentNode;
        }
        return Array.from((element || document).querySelectorAll("." + this.markClass))
            .filter((el) => el.offsetParent).pop();
    }
    wrapNextTextNodes(node, root) {
        const parentNodes = Array.from(node.parentNode.childNodes);
        const cuttedNodeIndex = parentNodes.indexOf(node);
        const nextTextNodes = parentNodes.splice(cuttedNodeIndex + 1).filter((node) => {
            return node.nodeType == Node.TEXT_NODE;
        });
        nextTextNodes.forEach((currentNode) => {
            const span = document.createElement('span');
            span.textContent = currentNode.textContent;
            node.parentNode.replaceChild(span, currentNode);
        });
        if (node != root) {
            this.wrapNextTextNodes(node.parentNode, root);
        }
    }
    unMarkRootIfNotExcluded(element) {
        const hasExcludedClass = this.maskingOptions.ExcludeClasses
            .some((className) => dom.hasClass(element, className));
        if (!hasExcludedClass) {
            this.unMarkElement(element);
        }
        return hasExcludedClass;
    }
    getTextNodes(node, acc) {
        if (node.nodeType == Node.ELEMENT_NODE && this.hasMark(node)) { // 1
            return acc;
        }
        for (let i = 0; i < node.childNodes.length; i++) {
            const child = node.childNodes[i];
            if (node.offsetParent) { // visible element + ignore script
                this.getTextNodes(child, acc);
            }
        }
        if (node.nodeType == Node.TEXT_NODE) { // 3
            acc.push(node);
        }
        return acc;
    }
    addTerminator(element, textElement) {
        element.innerText = textElement + this.maskingOptions.Terminator;
    }
    getNotMarkedElements(element) {
        return dom.find(':not(.' + this.markClass + ')', element);
    }
    hasMark(element) {
        return dom.hasClass(element, this.markClass);
    }
    removeNotMarked(element) {
        let excludedElements = this.getExcludedElements(element);
        let children = element.children;
        if (excludedElements && excludedElements.length === 0) {
            if (!this.hasMark(element)) {
                this.clearElement(element);
            }
        }
        else {
            element.style.margin = '0px';
        }
        if (children && children.length > 0) {
            Array.from(element.children).forEach((child) => {
                if (!dom.hasClass(child, this.markClass)) {
                    if (child.children && child.children.length > 0) {
                        this.removeNotMarked(child);
                    }
                    else {
                        this.clearElement(child);
                    }
                }
                else {
                    this.removeNotMarked(child);
                }
            });
        }
        else {
            if (!dom.hasClass(element, this.markClass)) {
                this.clearElement(element);
            }
        }
    }
    removeNotMarkedFade(element) {
        let excludedElements = this.getExcludedElements(element);
        let children = element.children;
        if (excludedElements && excludedElements.length === 0) {
            if (!this.hasMark(element)) {
                this.clearElementFade(element);
            }
        }
        else {
            element.style.margin = '0px';
        }
        if (children && children.length > 0) {
            Array.from(element.children).forEach((child) => {
                if (!dom.hasClass(child, this.markClass)) {
                    if (child.children && child.children.length > 0) {
                        this.removeNotMarkedFade(child);
                    }
                    else {
                        this.clearElementFade(child);
                    }
                }
                else {
                    this.removeNotMarkedFade(child);
                }
            });
        }
        else {
            if (!dom.hasClass(element, this.markClass)) {
                this.clearElementFade(element);
            }
        }
    }
    markParentsToRootElement(node, root) {
        if (!root.contains(node) || node == root) {
            return;
        }
        let parent = node;
        do {
            parent = parent.parentNode;
            this.markElement(parent);
        } while (parent != root);
    }
    markElement(node) {
        node.classList.add(this.markClass);
    }
    unMarkElement(element) {
        dom.removeClass(element, this.markClass);
    }
    textContent(childNode) {
        let that = this;
        return [].reduce.call(childNode.childNodes, function (a, b) {
            return a + (that.isTextNodeType(b) ? b.textContent.trim() : '');
        }, '');
    }
    isTextNodeType(element) {
        if (element.nodeType === 3) {
            return true;
        }
        switch (element.nodeName) {
            case 'P':
            case 'SPAN':
                return true;
            default:
                return false;
        }
    }
    startElementHaveNeedLength(elementLengthWithChildren, isStart) {
        if (elementLengthWithChildren == this.maskingOptions.AllowedCharactersCount
            || this.isAllowedLength(elementLengthWithChildren) && isStart) {
            return true;
        }
        else {
            return false;
        }
    }
    isAllowedLength(length) {
        return length < this.maskingOptions.AllowedCharactersCount;
    }
    markChildren(children) {
        Array.from(children).forEach((child) => {
            if (child.children && child.children.length > 0) {
                this.markChildren(child.children);
            }
            this.markElement(child);
        });
    }
    getMarkElements(element) {
        return dom.find('.' + this.markClass, element);
    }
    removeMarkClass(element) {
        let findedMarked = this.getMarkElements(element);
        findedMarked.forEach((markedElement) => {
            dom.removeClass(markedElement, this.markClass);
        });
    }
    clearElement(element) {
        element.innerText = "";
        element.textContent = "";
        this.clearStyle(element);
    }
    clearElementFade(element) {
        dom.addClass(element, "mg2-fade-trim");
    }
    clearStyle(element) {
        if (!element)
            return;
        element.style.height = '0px !important';
        element.style.margin = '0px !important';
        element.style.padding = '0px !important';
    }
    removeAllText(element) {
        // loop through all the nodes of the element
        var nodes = element.childNodes;
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            // if it's a text node, remove it
            if (node.nodeType == Node.TEXT_NODE) {
                node.parentNode.removeChild(node);
                i--; // have to update our incrementor since we just removed a node from childNodes
            }
            else 
            // if it's an element, repeat this process
            if (node.nodeType == Node.ELEMENT_NODE) {
                this.clearStyle(node);
                this.removeAllText(node);
            }
        }
    }
    getUncutParent(node, root) {
        let uncutTags = ['A'], currentEl = node, uncutParent = null;
        if (currentEl == root && ['A'].includes(currentEl.tagName)) {
            return currentEl;
        }
        while (currentEl != root) {
            if (['A'].includes(currentEl.tagName)) {
                uncutParent = currentEl;
            }
            currentEl = currentEl.parentNode;
        }
        return uncutParent;
    }
}
